module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "fixed": "",
      "back": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    staticClass: "custom-form",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "cell-group"
  }, [_c('div', {
    staticClass: "input-cells"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-cells"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captText),
      expression: "captText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.captText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-cell"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.updateCapt
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-cells"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneCapt),
      expression: "phoneCapt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phoneCapt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneCapt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-cell"
  }, [_c('button', {
    staticClass: "btn-code",
    attrs: {
      "type": "button",
      "disabled": _vm.btnDisable
    },
    on: {
      "click": _vm.getPhoneCapt
    }
  }, [_vm._v(_vm._s(_vm.btnText))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-cells"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-cell"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "protocol-group"
  }, [_vm._v("\n        点击注册，即代表您已同意伟嘉安捷\n        "), _c('router-link', {
    staticClass: "protocol",
    attrs: {
      "to": "/auth/protocol"
    }
  }, [_vm._v("《注册协议》")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-group"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        已有账号！现在去 "), _c('router-link', {
    staticClass: "sign",
    attrs: {
      "to": "/auth/login",
      "replace": ""
    }
  }, [_vm._v("登录")])], 1)])]), _vm._v(" "), _c('toast', {
    attrs: {
      "show": _vm.toastShow,
      "text": _vm.toastText
    },
    on: {
      "hidden": function($event) {
        _vm.toastShow = false
      }
    }
  }), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("手机号码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("图形验证码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("短信验证码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-cell"
  }, [_c('label', [_vm._v("登录密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe93bd0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/register.vue
// module id = 385
// module chunks = 1